<template>
  <footer class="footer">
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <div class="va">
            <p>Copyright &copy; 2020 Gaming Illuminaughty</p>
            <br />
            <small>
              Built by <a href="https://neointeractive.dev">Neo Interactive</a>
            </small>
          </div>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <p></p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 43.75em) {
  .va {
    text-align: center;
  }
}
.footer {
  background: #0d0c10;
  margin-top: 10rem;
  color: #bf9c5a;
  border-top: 2px solid #bf9c5a;
  small,
  a {
    color: darken(#bf9c5a, 30%);
  }
  padding-bottom: 3rem;
}
.level {
  margin-bottom: 0 !important;
}
</style>
